import { getDomainBrand } from "@/lib/brand-config";

export function useWorkspaceBrand(user?: { brand?: string | null } | null) {
  const accountBrand = user?.brand?.toLowerCase();
  const roadmover = accountBrand === "roadmover" ||
    getDomainBrand(typeof window === "undefined" ? "" : window.location.hostname) === "roadmover";

  return { roadmover, brandName: roadmover ? "RoadMover" : "Gewgul" };
}
